/* eslint-disable */
import { Button, Checkbox, Grid } from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { navigate } from "gatsby";
import React, { useState, useEffect } from "react";
import Check from "../../assets/Icons/ContactUsForm/check.svg";
import hiringDevTeam from "../../assets/Icons/ContactUsForm/Hiring_Dev_Team.svg";
import hiringDevTeamHover from "../../assets/Icons/ContactUsForm/Hiring_Dev_Team_red.svg";
import machineLearning from "../../assets/Icons/ContactUsForm/Machine_Learning.svg";
import machineLearningHover from "../../assets/Icons/ContactUsForm/Machine_Learning_red.svg";
import projectOutsourcing from "../../assets/Icons/ContactUsForm/Project_outsourcing.svg";
import projectOutsourcingHover from "../../assets/Icons/ContactUsForm/Project_outsourcing_red.svg";
import ScaleIcon from "../../assets/Icons/ContactUsForm/ScaleIcon";
import UnCheck from "../../assets/Icons/ContactUsForm/uncheck.svg";
import DataService from "../../services/api/data_services";
import SnackBar from "../../templates/SnackBar";
import "./ContactUs.scss";

const INTEREST_OPTIONS = [
  {
    key: "consult",
    label: "Consult",
    renderIcon: (hover) => (
      <img
        src={hover ? projectOutsourcingHover : projectOutsourcing}
        alt="Project Outsourcing"
      />
    ),
  },
  {
    key: "audit",
    label: "Audit",
    renderIcon: (hover) => (
      <img
        src={hover ? hiringDevTeamHover : hiringDevTeam}
        alt="Hiring Dev Team"
      />
    ),
  },
  {
    key: "build",
    label: "Build",
    renderIcon: (hover) => (
      <img src={hover ? machineLearningHover : machineLearning} alt="build" />
    ),
  },
  {
    key: "scale",
    label: "Scale",
    renderIcon: (hover) => <ScaleIcon color={hover ? "#db4435" : "#000"} />,
  },
];

const ContactUs = ({ name, type }) => {
  const containerRef = React.useRef(null);
  let formData = {
    firstName: "",
    lastName: "",
    organization: "",
    jobTitle: "",
    email: "",
    phone: "",
    location: "",
    message: "",
    type: "",
    items: [],
    othersMessage: "",
    referral_source: "",
    referral_source_other: "",
  };

  // console.log(name, type);

  const [hoverKey, setHoverKey] = useState(null);
  const [contactusForm, setcontactusForm] = useState(formData);
  const [checked, setchecked] = useState(type);
  const [approval, setapproval] = useState(false);
  const [approvalOpt, setapprovalOpt] = useState(false);
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const [showError, setShowError] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState();
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedItems, setSelectedItems] = React.useState([]);

  // console.log(name);

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    margin: {
      width: "100%",
    },
    error: {
      color: "red",
      fontSize: "14px",
      paddingTop: "5px",
    },
  }));

  const offerData = [
    {
      label: "consult",
      items: [
        "Product Strategy",
        "CX Strategy",
        "AI & ML Strategy",
        "Application Modernisation",
        "AWS Solutions",
        "AI-Driven SDLC",
        "Data Architecture",
        "Disaster Recovery & Business Continuity Planning",
        "Digital Transformation",
        "Product Scaling",
        "Agile Transformation",
        "IT Risk & Assurance",
        "Others",
      ],
    },
    {
      label: "build",
      items: [
        "Product Designing & Prototyping",
        "MVP Development",
        "Mobile Application Development",
        "Web Application Development",
        "Full Product Development",
        "Capability Build",
        "Cloud Migration",
        "Data Science and Analytics",
        "Data Engineering",
        "Team Augmentation",
        "Agile POD",
        "Source Code Escrow",
        "Others",
      ],
    },
    {
      label: "audit",
      items: [
        "Vendor Capability & Compliance Audit",
        "Cost Optimisation Analysis",
        "Innovation Potential Assessment",
        "Technology Stack Audit",
        "Code & UX Audit",
        "Cloud Security Assessment",
        "Performance & Efficiency Audit",
        "Cloud Migration Readiness Assessment",
        "Compliance Audit",
        "CREST Penetration Testing",
        "Pre-Investment Risk Assessment",
        "Tech & Talent Due Diligence",
        "Others",
      ],
    },
    {
      label: "scale",
      items: [
        "Engineering PODs",
        "Team Augmentation",
        "Platform Evolution",
        "Managed Delivery",
        "Others",
      ],
    },
  ];

  const classes = useStyles();

  useEffect(() => {
    DataService.getData(`https://ipapi.co/json/`).then((res) =>
      setcontactusForm({ ...contactusForm, location: res.city })
    );
  }, []);

  useEffect(() => {
    if (type) {
      setchecked(type);
      if (name && !selectedItems.includes(name)) {
        const category = offerData.find((cat) => cat.label === type);
        if (category && category.items.includes(name)) {
          setSelectedItems((prevSelectedItems) => [...prevSelectedItems, name]);
        }
      }
    }
  }, [type, name]);

  const handleChange = (event, key) => {
    if (key === "firstName") {
      let validatedValue = event.target.value.replace(
        /[0-9`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: validatedValue });
    } else if (key == "lastName") {
      let validatedValue = event.target.value.replace(
        /[0-9`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: validatedValue });
    } else if (key == "organization") {
      let validatedValue = event.target.value.replace(
        /[0-9`~!@#$%^&*()_|+\-=?;:<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: validatedValue });
    } else if (key == "jobTitle") {
      let validatedValue = event.target.value.replace(
        /[0-9`~!@#$%^&*()_|+\-=?;:<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: validatedValue });
    } else if (key == "email") {
      let validatedValue = event.target.value.replace(
        /[0-9`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: event.target.value });
    } else if (key == "phone") {
      let validatedValue = event.target.value.replace(
        /[a-zA-Z`~!@#$%^&*()_|\=?;:'",.<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: validatedValue });
    } else if (key == "location") {
      let validatedValue = event.target.value.replace(
        /[0-9`~!@#$%^&*()_|+\-=?;:<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: validatedValue });
    } else if (key == "othersMessage") {
      setcontactusForm({ ...contactusForm, [key]: event.target.value });
    } else if (key == "message") {
      setcontactusForm({ ...contactusForm, [key]: event.target.value });
    } else if (key == "referral_source") {
      setcontactusForm({ ...contactusForm, [key]: event.target.value });
    } else if (key == "referral_source_other") {
      setcontactusForm({ ...contactusForm, [key]: event.target.value });
    }
  };

  const handleCheckbox = (value) => {
    setchecked(value);
    setSelectedItems([]);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleItemClick = (item) => {
    if (selectedItems.includes(item)) {
      setSelectedItems(selectedItems.filter((i) => i !== item));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    contactusForm.type = checked;
    contactusForm.items = selectedItems;
    contactusForm.privacy_policy = approval;
    contactusForm.opt_in = approvalOpt;
    // setchecked([]);
    setcontactusForm(formData);

    let modifyObjet = {
      email: contactusForm.email,
      firstName: contactusForm.firstName,
      lastName: contactusForm.lastName,
      jobTitle: contactusForm.jobTitle,
      location: contactusForm.location,
      email: contactusForm.email,
      opt_in: contactusForm.opt_in,
      organization: contactusForm.organization,
      phone: contactusForm.phone,
      privacy_policy: contactusForm.privacy_policy,
      interestedIn: [
        contactusForm.type,
        ...(contactusForm?.items || []),
        contactusForm?.othersMessage,
      ].filter(Boolean),
      message: contactusForm?.message,
      referral_source: contactusForm?.referral_source,
      referral_source_other: contactusForm?.referral_source_other,
    };
    // setapproval(false);

    approval === true &&
      DataService.postData(`admin/api/sendmail`, modifyObjet, {
        type: "contactus",
      })
        .then((response) => {
          if (typeof window !== `undefined`) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "generate_lead",
              page_location: window.location.href,
              contact_method: "form",
              form_name: "contact_us",
            });
            navigate(`/thank-you-contact`);
          }
        })
        .catch((error) => {
          setSnackbarStatus(true);
          setSnackbarMessage(error.message);
        });
  };

  const validateRequiredFields = () => {
    let errors = {};

    if (!contactusForm.firstName) errors.firstName = "First name is required";
    if (!contactusForm.lastName) errors.lastName = "Last name is required";
    if (!contactusForm.email) errors.email = "Email is required";
    if (!contactusForm.phone) errors.phone = "Phone is required";
    if (!contactusForm.referral_source)
      errors.referral_source = "Referral source is required";

    if (
      contactusForm.referral_source === "Other" &&
      !contactusForm.referral_source_other
    ) {
      errors.referral_source_other = "Please specify how you heard about us";
    }

    return errors;
  };

  const validateSubmit = (e) => {
    const errors = validateRequiredFields();
    console.log(errors);

    if (approval === true) {
      setShowError(false);
      handleSubmit(e);
    } else {
      setShowError(true);
    }
  };

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const currentCategory = offerData.find((cat) => cat.label === checked);

  return (
    <div className="body-container">
      <SnackBar
        isOpen={snackbarStatus}
        message={snackbarMessage}
        close={() => setSnackbarStatus(false)}
      />
      <Grid className="contactus-subtitle" container direction="column">
        <Grid className="mt-50" item xs={12} sm={4} md={6}>
          <b>I'm interested in...</b>
        </Grid>
      </Grid>
      <Grid className="mt-20" container justify="flex-start" spacing={2}>
        {INTEREST_OPTIONS.map((opt) => (
          <Grid item xs={6} sm={4} md={2} key={opt.key}>
            <div
              role="presentation"
              className={
                checked === opt.key
                  ? "contactus-icon-area contactus-icon-area-checked"
                  : "contactus-icon-area"
              }
              onMouseEnter={() => setHoverKey(opt.key)}
              onMouseLeave={() => setHoverKey(null)}
              onClick={() => handleCheckbox(opt.key)}
            >
              {checked === opt.key ? (
                <img src={Check} alt="checkbox" className="checkbox-icon" />
              ) : (
                <img src={UnCheck} alt="checkbox" className="checkbox-icon" />
              )}

              {opt.renderIcon(hoverKey === opt.key)}

              <div className="interestedin-icon-title">{opt.label}</div>
            </div>
          </Grid>
        ))}
      </Grid>
      <div>
        <Grid className="mt-50" container spacing={2} direction="row">
          <Grid item xs={12} sm={12} md={6}>
            <div className="floating">
              <input
                id="first_name"
                className="floating__input"
                name="first_name"
                type="text"
                placeholder="First Name *"
                onChange={(event) => handleChange(event, "firstName")}
                value={contactusForm.firstName}
                maxlength="50"
              />
              <label
                htmlFor="first_name"
                className="floating__label"
                data-content="First Name *"
              >
                <span className="hidden--visually">First Name</span>
              </label>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <div className="floating">
              <input
                id="last_name"
                className="floating__input"
                name="last_name"
                type="text"
                placeholder="Last Name *"
                onChange={(event) => handleChange(event, "lastName")}
                value={contactusForm.lastName}
                maxlength="50"
              />
              <label
                htmlFor="last_name"
                className="floating__label"
                data-content="Last Name *"
              >
                <span className="hidden--visually">Last Name</span>
              </label>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <div className="floating">
              <input
                id="Organization"
                className="floating__input"
                name="Organization"
                type="text"
                placeholder="Organisation"
                onChange={(event) => handleChange(event, "organization")}
                value={contactusForm.organization}
                maxlength="50"
              />
              <label
                htmlFor="Organization"
                className="floating__label"
                data-content="Organisation"
              >
                <span className="hidden--visually">Organisation</span>
              </label>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <div className="floating">
              <input
                id="job_title"
                className="floating__input"
                name="job_title"
                type="text"
                placeholder="Job Title"
                onChange={(event) => handleChange(event, "jobTitle")}
                value={contactusForm.jobTitle}
                maxlength="50"
              />
              <label
                htmlFor="job_title"
                className="floating__label"
                data-content="Job Title"
              >
                <span className="hidden--visually">Job Title</span>
              </label>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <div className="floating">
              <input
                id="email"
                className="floating__input"
                name="email"
                type="email"
                placeholder="Email *"
                onChange={(event) => handleChange(event, "email")}
                value={contactusForm.email}
                maxlength="180"
              />
              <label
                htmlFor="email"
                className="floating__label"
                data-content="Email *"
              >
                <span className="hidden--visually">Email</span>
              </label>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <div className="floating">
              <input
                id="phone"
                className="floating__input"
                name="phone"
                type="tel"
                placeholder="Phone *"
                onChange={(event) => handleChange(event, "phone")}
                value={contactusForm.phone}
                maxlength="15"
              />
              <label
                htmlFor="phone"
                className="floating__label"
                data-content="Phone *"
              >
                <span className="hidden--visually">Phone</span>
              </label>
            </div>
          </Grid>

          {checked && (
            <Grid item xs={12} sm={12} md={6}>
              <div className="multi-select-container" ref={containerRef}>
                <div className="multi-select-header" onClick={toggleDropdown}>
                  <span>{`${selectedItems.length} item(s) selected`}</span>
                  <span>{isOpen ? "▲" : "▼"}</span>
                </div>
                <div
                  className={`multi-select-dropdown ${isOpen ? "open" : ""}`}
                >
                  <div className="category-section">
                    {currentCategory?.items?.map((item) => (
                      <div
                        key={item}
                        className={`multi-select-item ${
                          selectedItems.includes(item) ? "selected" : ""
                        }`}
                        onClick={() => handleItemClick(item)}
                      >
                        <input
                          type="checkbox"
                          checked={selectedItems.includes(item)}
                          onChange={() => {}}
                        />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Grid>
          )}

          {selectedItems.includes("Others") && (
            <Grid item xs={12} sm={12} md={6}>
              <div className="floating">
                <input
                  id="othersMessage"
                  className="floating__input"
                  name="othersMessage"
                  type="text"
                  placeholder="Write message for Others"
                  onChange={(event) => handleChange(event, "othersMessage")}
                  value={contactusForm.othersMessage}
                  maxlength="30"
                />
                <label
                  htmlFor="othersMessage"
                  className="floating__label"
                  data-content="Others *"
                >
                  <span className="hidden--visually">Others</span>
                </label>
              </div>
            </Grid>
          )}

          {/* referral_source start  */}

          <Grid item xs={12} sm={12} md={6}>
            <div className="floating">
              <select
                name="referral_source"
                className="floating__input"
                onChange={(event) => handleChange(event, "referral_source")}
                value={contactusForm.referral_source}
                id="referral_source"
                required
              >
                <option value="" disabled>Select an option</option>
                <option value="Google Search">Google Search</option>
                <option value="Facebook Ads">Facebook Ads</option>
                <option value="LinkedIn">LinkedIn</option>
                <option value="Instagram">Instagram</option>
                <option value="Clutch">Clutch</option>
                <option value="Referral">Referral</option>
                <option value="Other">Other</option>
              </select>
              <label
                htmlFor="referral_source"
                className="floating__label"
                data-content="How did you hear about *"
              >
                <span className="hidden--visually">How did you hear about</span>
              </label>
            </div>
          </Grid>

          {contactusForm.referral_source === "Other" && (
            <Grid item xs={12} sm={12} md={6}>
              <div className="floating">
                <input
                  id="referral_source_other"
                  className="floating__input"
                  name="referral_source_other"
                  type="text"
                  placeholder="Write message for Others"
                  onChange={(event) =>
                    handleChange(event, "referral_source_other")
                  }
                  value={contactusForm.referral_source_other}
                  maxlength="30"
                />
                <label
                  htmlFor="referral_source_other"
                  className="floating__label"
                  data-content="Please specify *"
                >
                  <span className="hidden--visually">Please specify</span>
                </label>
              </div>
            </Grid>
          )}

          {/* referral_source end */}

          <Grid item xs={12} sm={12} md={12}>
            <TextField
              label="How can we help?"
              multiline
              rows={3}
              variant="filled"
              id="description"
              name="description"
              onChange={(event) => handleChange(event, "message")}
              value={contactusForm.message}
              InputLabelProps={{
                style: { color: "#0000008a", fontSize: "18px" },
              }}
              InputProps={{
                disableUnderline: true,
                fullWidth: true,
                style: {
                  backgroundColor: "white",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                },
              }}
              style={{ width: "100%" }}
              inputProps={{ maxLength: 10000 }}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <div className="contact-mb">
              <div
                role="presentation"
                onChange={() => {
                  setapproval(!approval);
                  setShowError(false);
                  handleChange(!approval, "privacy_policy");
                }}
              >
                <Checkbox
                  color="primary"
                  checked={approval}
                  inputProps={{ "aria-label": "secondary checkbox" }}
                />
              </div>
              <div
                style={{ margin: "auto", marginLeft: "5px" }}
                className="approval-text"
              >
                <i>
                  I agree to share my information with you and understand it
                  will be used as described in{" "}
                  <a
                    className="atagclass"
                    target="_blank"
                    href="/privacy-policy"
                  >
                    DigiRyte's privacy policy.
                  </a>
                </i>
                {showError === true && (
                  <FormHelperText className={classes.error}>
                    *This permission is required before we collect your
                    information
                  </FormHelperText>
                )}
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <div
              style={{ marginTop: "20px" }}
              role="presentation"
              onClick={(e) => {
                contactusForm.firstName &&
                  contactusForm.lastName &&
                  contactusForm.email &&
                  contactusForm.phone &&
                  contactusForm.referral_source &&
                  // ) && handleSubmit(e) }}>
                  validateSubmit(e);
              }}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ boxShadow: "none" }}
                size="large"
                disabled={
                  !(
                    contactusForm.firstName &&
                    contactusForm.lastName &&
                    contactusForm.email &&
                    contactusForm.phone
                  )
                }
                routepath="/thank-you-contact"
              >
                SUBMIT
              </Button>
            </div>
          </Grid>
        </Grid>
        {/* <SnackBar /> */}
      </div>
    </div>
  );
};

export default ContactUs;
